/**
 * The agency chooser (TZ §17.2). Shown once to a person who belongs to several agencies and has
 * not picked one yet. Nothing else of the product loads until they do: every request would be
 * refused without a named agency.
 */
import type { JSX } from "react";

import { useTranslation, type TranslationKey } from "@/i18n";
import { useAuthStore } from "@/store/auth";
import { Button } from "@/ui/button";

import { AuthFrame, AuthHeading } from "./AuthFrame";

export function AgencyChooser(): JSX.Element {
  const { t } = useTranslation();
  const agencies = useAuthStore((state) => state.agencies);
  const switchAgency = useAuthStore((state) => state.switchAgency);

  return (
    <AuthFrame>
        <AuthHeading title={t("agency.choose.title")} lead={t("agency.choose.hint")} />
        <ul className="flex flex-col gap-2">
          {agencies.map((agency) => (
            <li key={agency.id}>
              <Button
                variant="secondary"
                className="w-full justify-between"
                onClick={(): void => {
                  switchAgency(agency.id);
                }}
              >
                <span>{agency.name}</span>
                <span className="text-sm text-ink-subtle">{t(`role.${agency.role}` as TranslationKey)}</span>
              </Button>
            </li>
          ))}
        </ul>
    </AuthFrame>
  );
}
